module.exports = __webpack_public_path__ + "img/alba-logo.7b635914.png";